<div class="min-h-screen overflow-x-hidden bg-white font-inter text-slate-950">
  <!-- Fixed Header -->
  <app-home-header-section></app-home-header-section>

  <!-- Page Content with top padding for fixed header -->
  <div class="pt-20">
    <router-outlet></router-outlet>
  </div>

  <!-- Footer -->
  <app-home-footer-section></app-home-footer-section>
</div>

